import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import { PartRegion } from '@/features/storefront/parts/PartRegion';
import type { ProductViewProps } from '@/features/storefront/layouts/product/types';

/**
 * A trade counter's product page: the tool, and the numbers about it.
 *
 * Arranged for somebody who arrived knowing roughly what they want and is
 * checking whether this is it - so the price, the variant and the button are
 * reachable without scrolling, and the specifications sit directly under them
 * rather than below a page of prose. The buy column stays put while the
 * description runs on, which is what stops a long spec sheet from scrolling the
 * "add to cart" button off the top of a decision.
 *
 * Square rather than portrait, and thumbs stood up in a rail beside the
 * picture: a drill photographed portrait is mostly floor.
 */
export const Product: FC<ProductViewProps> = () => (
  <StorefrontContainer className="grid gap-10 py-8 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] lg:gap-14">
    <PartRegion name="gallery" />
    <PartRegion name="main" className="min-w-0 lg:sticky lg:top-24 lg:self-start" />
  </StorefrontContainer>
);
